import { render, staticRenderFns } from "./LabDetails.vue?vue&type=template&id=1f0bd1be&"
import script from "./LabDetails.vue?vue&type=script&lang=js&"
export * from "./LabDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports